import { mapActions, mapGetters } from "vuex";
import toast from "@/utils/toast";
import { cleanObject } from "./utils/utils";

export default {
  name: "IdpEnrollmentMain",

  components: {},
  data() {
    return {
      filters: {
        page: 1,
        pageSize: 12,
        order: "desc",
        field: "updated_at",
        search: "",
        learning_type: "structured_learning",
        idp_period_id: null,
        type:"un-enrollment",
        all: false,
      },
      isLoading: false,
      isModalLoading: false,
      isLoadingSummary: false,
      _searchTimer: null,
      showModal: false,
      modalData: null,
      idpPeriodOptions: [],
      activeFiltersCount: 0,
    };
  },

  computed: {
    ...mapGetters("idpEnrollment", [
      "idpLearnings",
      "summaryIdpLearning",
      "trainingMethods",
      "trainingTypes",
      "competencies",
    ]),

    showingFrom() {
      if (!this.idpLearnings.total) return 0;
      return (this.filters.page - 1) * this.filters.pageSize + 1;
    },

    showingTo() {
      const to = this.filters.page * this.filters.pageSize;
      return to > this.idpLearnings.total ? this.idpLearnings.total : to;
    },
  },

  watch: {
    filters: {
      deep: true,
      handler(newFilters) {
        this.updateUrlQuery(newFilters);
      },
    },

    "filters.idp_period_id"() {
      this.filters.page = 1;

      this.loadSummaryLearning();
      this.loadData();
    },

    "$route.query": {
      handler() {
        this.syncFiltersFromQuery();
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions("idpEnrollment", [
      "getIdpLearnings",
      "getStructuredLearningDetail",
      "submitIdpLearning",
      "getSummaryIdpLearning",
      "getIdpPeriod",
      "getTrainingMethods",
      "getTrainingTypes",
      "getCompetencies",
      "resetIdpLearnings",
    ]),

    showFilterModal() {
      this.$bvModal.show("modal-filter");
    },

    buildQueryFromFilters() {
      const raw = {
        page: this.filters.page,
        pageSize: this.filters.pageSize,
        order: this.filters.order,
        field: this.filters.field,
        search: this.filters.search,
        all: this.filters.all,
        learning_type: this.filters.learning_type,
        idp_period_id: this.filters.idp_period_id,
        training_scope: this.filters.training_scope,
        training_category: this.filters.training_category,
        platform: this.filters.platform,
        training_method_id: this.filters.training_method_id,
        training_type: this.filters.training_type,
        competency_id: this.filters.competency_id,
        type: "un-enrollment",
      };

      return cleanObject(raw);
    },

    async loadData() {
      try {
        this.isLoading = true;

        const query = this.buildQueryFromFilters();

        await this.getIdpLearnings(query);

        if (this.idpLearnings.page) this.filters.page = this.idpLearnings.page;
        if (this.idpLearnings.limit) this.filters.pageSize = this.idpLearnings.limit;
      } finally {
        this.isLoading = false;
      }
    },

    onPageChange(payload) {
      let page = null;
      if (typeof payload === "number") page = payload;
      else if (payload?.currentPage !== undefined) page = payload.currentPage;
      else if (payload?.currentPageNumber !== undefined) page = payload.currentPageNumber;
      if (page === null) return;
      this.filters.page = page;
      this.loadData();
    },

    onPageChangeFromBv(page) {
      this.filters.page = page;
      this.loadData();
    },

    onPerPageChange(payload) {
      let per = null;
      if (typeof payload === "number") per = payload;
      else if (payload?.currentPerPage !== undefined) per = payload.currentPerPage;
      else if (payload?.perPage !== undefined) per = payload.perPage;
      if (per === null) return;
      this.filters.pageSize = per;
      this.filters.page = 1;
      this.loadData();
    },

    onSortChange(params) {
      if (!Array.isArray(params) || params.length === 0) return;
      const { field, type } = params[0] || {};
      const isReset = type === "none";
      this.filters = {
        ...this.filters,
        field: isReset ? null : field,
        order: isReset ? null : type || "asc",
        page: 1,
      };
      this.loadData();
    },

    onSearch() {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.filters.page = 1;
        this.loadData();
      }, 500);
    },

    clearFilter() {
      this.filters = { ...this.filters, search: "", page: 1 };
      this.loadData();
    },

    async openDetailModal(row) {
      this.isModalLoading = true;
      this.selectedId = row.id;
      this.showModal = true;

      const detail = await this.getStructuredLearningDetail({ id: row.id });

      this.modalData = detail;

      this.$nextTick(() => {
        this.$bvModal.show("structured-learning-modal");
      });
      this.isModalLoading = false;
    },

    updateUrlQuery(filters) {
      const query = cleanObject({
        ...this.$route.query,
        page: filters.page,
        pageSize: filters.pageSize,
        order: filters.order,
        field: filters.field,
        search: filters.search,
      });

      const current = JSON.stringify(this.$route.query);
      const next = JSON.stringify(query);

      if (current !== next) {
        this.$router.replace({ query }).catch(() => { });
      }
    },

    syncFiltersFromQuery() {
      const query = this.$route.query;
      const parsed = {
        page: Number(query.page) || 1,
        pageSize: Number(query.pageSize) || 12,
        order: query.order || null,
        field: query.field || null,
        search: query.search || "",
      };

      Object.keys(parsed).forEach((key) => {
        this.$set(this.filters, key, parsed[key]);
      });
    },

    async submitUnEnrollment(payload) {
      this.$bvModal.hide("structured-learning-modal");

      this.$nextTick(() => {
        this.$swal({
          title: "Apakah Anda yakin?",
          text: "Isi catatan untuk pembatalan pendaftaran ini.",
          icon: "warning",
          input: "text",
          inputPlaceholder: "Masukkan catatan...",
          showCancelButton: true,
          confirmButtonColor: "#00D97E",
          cancelButtonColor: "#E63757",
          confirmButtonText: "Ya, kirim",
          cancelButtonText: "Batal"
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              const notes = result.value;

              await this.submitIdpLearning({
                query: { learning_type: "structured_learning", type: "un-enrollment" },
                data: { ...payload, notes }
              });

              toast({
                type: "success",
                title: "Success",
                message: "Pembatalan pendaftaran berhasil"
              });
            } catch (error) {
              const msg = error?.response?.data?.error || error?.message || "Terjadi kesalahan.";
              toast({ type: "error", title: "Error", message: msg });
            } finally {
              this.loadData();
            }
          }
        });
      });
    },

    async loadSummaryLearning() {
      this.isLoadingSummary = true;

      const payload = {
        learning_type: "structured_learning",
        type: "un-enrollment",
      };

      if (this.filters.idp_period_id) payload.idp_period_id = this.filters.idp_period_id;

      await this.getSummaryIdpLearning(payload);

      this.isLoadingSummary = false;
    },

    async loadIdpPeriod() {
      const idpPeriod = await this.getIdpPeriod();

      this.filters.idp_period_id = idpPeriod.find((p) => p.status === "open")?.id || null;

      this.idpPeriodOptions = idpPeriod.map((p) => ({
        text: this.formatPeriodLabel(p.start_date, p.end_date),
        value: p.id,
      }));
    },

    formatPeriodLabel(startDate, endDate) {
      if (!startDate || !endDate) return "";

      const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };

      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    },

    applyFilters(appliedFilters) {
      const cleaned = cleanObject(appliedFilters);

      Object.entries(cleaned).forEach(([key, val]) => {
        this.$set(this.filters, key, val);
      });

      this.$set(this.filters, "page", 1);
      this.updateActiveFilterCount();
      this.loadData();

      this.$bvModal.hide("modal-filter");
    },

    updateActiveFilterCount() {
      const { training_scope, training_category, platform, training_method_id, training_type, competency_id } = this.filters;
      const vals = [training_scope, training_category, platform, training_method_id, training_type, competency_id];

      this.activeFiltersCount = vals.filter((x) => x !== null && x !== undefined && x !== "").length;
    },

    resetFilters() {
      const reset = {
        training_scope: null,
        training_category: null,
        platform: null,
        training_method_id: null,
        training_type: null,
        competency_id: null,
        page: 1,
      };

      Object.entries(reset).forEach(([key, val]) => {
        this.$set(this.filters, key, val);
      });

      this.activeFiltersCount = 0;

      this.loadData();
    },

    clearSingleFilter(filterKey) {
      if (this.filters.hasOwnProperty(filterKey)) {
        this.$set(this.filters, filterKey, null);
        this.filters.page = 1;
        this.updateActiveFilterCount();
        this.loadData();
      }
    },
  },

  async mounted() {
    this.syncFiltersFromQuery();
    await this.loadIdpPeriod();

    await Promise.all([
      this.loadSummaryLearning(),
      this.getTrainingMethods(),
      this.getTrainingTypes(),
      this.getCompetencies(),
      this.loadData(),
    ]);
  },

  beforeDestroy() {
    clearTimeout(this._searchTimer);
    this.resetIdpLearnings();
  },
};
